// Import required modules
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import enTranslation from './locales/en.json';
import frTranslation from './locales/fr.json';
import { CONFIG } from './environment';

// Configure i18next
i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslation,
    },
    fr: {
      translation: frTranslation,
    },
  },
  lng: CONFIG.APP_DEFAULT_LANGUAGE, // Set the default language
  fallbackLng: CONFIG.APP_DEFAULT_LANGUAGE, // Set the fallback language
  interpolation: {
    escapeValue: false, // Disable HTML escaping
  },
});

export default i18n;
